/**
 * Show a window.showAlert for a failed API call using the shared 404 / 4xx / 5xx branching.
 *
 * @param {object} error - Error with optional `status` (as thrown by our API helpers)
 * @param {{ notFound?: string, client?: string, default?: string }} [messages]
 */
export function alertFromApiError(error, messages = {}) {
    const {
        notFound = 'Resource not found',
        client = 'Invalid data. Please check your input.',
        default: defaultMessage = 'Something went wrong. Please try again.',
    } = messages;

    if (!window.showAlert) return;

    if (error?.status === 404) {
        window.showAlert(404, notFound);
    } else if (error?.status >= 400 && error?.status < 500) {
        window.showAlert(error.status, client);
    } else {
        window.showAlert(error?.status || 500, defaultMessage);
    }
}
